import React from 'react';

const CBTable = ({
  columns = [], // Array of { title: string, dataIndex: string, key: string, render?: (text, record, index) => ReactNode }
  dataSource = [], // Array of data objects
  rowKey = 'key', // Field name in dataSource to use as key, or a function (record, index) => key
  className = '',
  loading = false, // Optional loading state
  // Add other props like pagination, sorting handlers later if needed
}) => {
  const getRowKey = (record, index) => {
    if (typeof rowKey === 'function') {
      return rowKey(record, index);
    }
    return record[rowKey] || index; // Fallback to index if key is missing
  };

  return (
    <div className={`overflow-x-auto ${className}`}>
      <table className="min-w-full divide-y divide-gray-200 border border-gray-200">
        <thead className="bg-gray-50">
          <tr>
            {columns.map((col) => (
              <th
                key={col.key || col.dataIndex}
                scope="col"
                className="px-6 py-3 text-left  font-medium text-gray-500 uppercase tracking-wider"
              >
                {col.title}
              </th>
            ))}
          </tr>
        </thead>
        <tbody className="bg-white divide-y divide-gray-200">
          {loading && (
            <tr>
              <td colSpan={columns.length} className="text-center py-4">
                {/* Add a simple loading indicator or use CBSpin if available */}
                Loading...
              </td>
            </tr>
          )}
          {!loading && dataSource.length === 0 && (
             <tr>
               <td colSpan={columns.length} className="text-center py-4 text-gray-500">
                 {/* Use CBEmpty if available */}
                 No Data
               </td>
             </tr>
           )}
          {!loading && dataSource.map((record, index) => (
            <tr key={getRowKey(record, index)} className="hover:bg-gray-50">
              {columns.map((col) => {
                const text = record[col.dataIndex];
                const renderedCell = col.render
                  ? col.render(text, record, index)
                  : text;
                return (
                  <td
                    key={col.key || col.dataIndex}
                    className="p-6  whitespace-nowrap text-lg text-gray-700"
                  >
                    {renderedCell}
                  </td>
                );
              })}
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
};

export { CBTable };